// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './utils/DateUtil'
import './directives'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import EventBus from './utils/EventBus'
import apis from './apis'
import MyComponent from './components'

import './utils/leaflet.ChineseTmsProviders'

import 'font-awesome/scss/font-awesome.scss'

import dataV from '@jiaminghi/data-view'
import unitConverter from './utils/unitConverter'

Vue.use(dataV)
Vue.use(ElementUI)

const eventBus = new EventBus()
Vue.prototype.$eventBus = eventBus

Vue.prototype.$unitConverter = unitConverter

Vue.use(apis, {
  eventBus,
  getToken: () => store.getters['Profile/token']
})

Vue.use(MyComponent)

store.dispatch('Profile/addListener', null).then(() => {})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js